import React from 'react';

import Admin from 'hive-admin';

import { Link } from 'react-router-dom';
import PageArchiveTable from '../../components/PageArchiveTable';

// import tests from '../../helpers/tests';

import { ADMIN as ADMIN_FILTERS } from './filters';
import { ADMIN as ADMIN_FIELDS } from './fields';

import Types from '../../modules/types';

// const { viewerIsNotAdmin } = tests;

export default (
  Admin.compileFromLibrary(['GroupResource', {
    title: 'Pricing',
    // icon: 'dollar',
    path: '/shipping/pricing',
    singleLoadUrl: '/pricing/:id',
    archiveLoadUrl: '/pricing',
    duplicateLoadUrl: '/pricing/:duplicate',
    redirect: [
      ['redirect.unauthorized'],
      // [
      //   'redirect.checkViewer',
      //   'role', '!==', 'ADMIN',
      //   '/store',
      // ],
    ],
    archiveConfig: {
      // icon: 'dollar',
      title: 'Pricing',
      label: 'Pricing',
      createButtonPath: '/shipping/pricing/create',
      // hidden: [viewerIsNotAdmin],
      getColumns: (props, columns) => {
        const { viewer } = props;
        if (viewer?.role === 'ADMIN') {
          return PageArchiveTable.defaultProps.getColumns(props, columns);
        }
        return PageArchiveTable.defaultProps.getColumns(
          props,
          (columns || props.columns).filter(
            column => column.path !== 'store.name'
          ),
        );
      },
    },
    singleConfig: {
      hidden: true,
      alias: '/shipping/pricing',
      backButtonPaths: ['/shipping/pricing'],
    },
    singleEditConfig: {
      actions: [
        ['ActionSaveAndReload'],
        ['ActionDelete'],
        ['Action', {
          name: 'duplicate',
          title: 'Duplicate',
          ghost: true,
          onClick: (props) => props.history.push(
            `/shipping/pricing/create?duplicate=${
              props.data ? props.data._id : null
            }`
          ),
        }],
      ],
    },
    filters: ADMIN_FILTERS,
    columns: [
      {
        path: 'name',
        link: '/shipping/pricing/:_id',
        width: '100%',
      },
      {
        path: 'countries',
        align: 'right',
        render: record => (
          record
          .countries
          .map(country => country.toUpperCase())
          .join(', ')
        ),
      },
      {
        title: 'Store',
        path: 'store.name',
        render: (record) => (
          record.store?.name
          ? (
              <Link to={`/stores/${record.store._id}`}>
                {record.store.name}
              </Link>
            )
          : '-'
        ),
      },
      ...Types.SHIPPING_PRICING_METHOD.map((pricingMethod) => {
        const result = {
          align: 'right',
          title: Types.SHIPPING_PRICING_METHOD_LABELS_MAP[pricingMethod],
          path: `methods.${pricingMethod}`,
          render: (record) => {
            const method = record?.methods[pricingMethod];
            return (
              method && method.supported
              ? (
                  method.shippingCompany && method.shippingCompany.name
                  ? (
                      <Link
                        to={`/shipping/companies/${method.shippingCompany._id}`}
                      >
                        {`${method.shippingCompany.name}`}
                      </Link>
                    )
                  : '✓'
                )
              : '-'
            );
          },
        };
        return result;
      }),
    ],
    fields: ADMIN_FIELDS,
  }])
).pages;
